import CryptoIcon from '@/shared/assets/crypto-icon.svg?react';
import BankIcon from '@/shared/assets/bank-icon.svg?react';
import CardIcon from '@/shared/assets/card-icon.svg?react';
import OplatiIcon from '@/shared/assets/oplati-icon.svg?react';
import SberpayIcon from '@/shared/assets/sberpay-icon.svg?react';
import SbpIcon from '@/shared/assets/sbp-icon.svg?react';
import SccrsIcon from '@/shared/assets/sccrs-icon.svg?react';
import type { OperationType } from '@/shared/types';
import type { OperationMethod } from './types';

export const DEPOSIT_METHODS: Omit<OperationMethod, 'isAvailable'>[] = [
  {
    key: 'deposit.sberpay',
    translationKey: 'depositMethods.sberpay',
    iconComponent: SberpayIcon,
  },
  {
    key: 'deposit.sbp',
    translationKey: 'depositMethods.sbp',
    iconComponent: SbpIcon,
  },
  {
    key: 'deposit.card',
    translationKey: 'depositMethods.creditCard',
    additionalText: true,
    iconComponent: CardIcon,
  },
  {
    key: 'deposit.bank',
    translationKey: 'depositMethods.bankTransfer',
    iconComponent: BankIcon,
  },
  {
    key: 'deposit.oplati',
    translationKey: 'depositMethods.oplati',
    iconComponent: OplatiIcon,
  },
  {
    key: 'deposit.erip',
    translationKey: 'depositMethods.erip',
    iconComponent: '/assets/erip-icon.png',
  },
  {
    key: 'deposit.crypto',
    translationKey: 'depositMethods.crypto',
    iconComponent: CryptoIcon,
  },
  {
    key: 'deposit.sccrs',
    translationKey: 'depositMethods.sccrs',
    iconComponent: SccrsIcon,
  },
];

export const WITHDRAW_METHODS: Omit<OperationMethod, 'isAvailable'>[] = [
  {
    key: 'withdraw.crypto',
    translationKey: 'withdrawMethods.crypto',
    iconComponent: CryptoIcon,
  },
  {
    key: 'withdraw.bank',
    translationKey: 'withdrawMethods.bankTransfer',
    iconComponent: BankIcon,
  },
  {
    key: 'withdraw.card',
    translationKey: 'withdrawMethods.card',
    iconComponent: CardIcon,
  },
  {
    key: 'withdraw.sbp',
    translationKey: 'withdrawMethods.sbp',
    iconComponent: SbpIcon,
  },
  {
    key: 'withdraw.sccrs',
    translationKey: 'withdrawMethods.sccrs',
    iconComponent: SccrsIcon,
  },
];

export const OPERATION_METHODS_CONFIG: Record<
  OperationType,
  Omit<OperationMethod, 'isAvailable'>[]
> = {
  deposit: DEPOSIT_METHODS,
  withdraw: WITHDRAW_METHODS,
  exchange: [],
  transfer: [],
};
